// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconAptsrusde } from "../../../icons/mono/build/icon-aptsrusde.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const AptsrusdeIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconAptsrusde.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  AptsrusdeIcon.displayName = 'AptsrusdeIcon';
}

export default AptsrusdeIcon;